<svelte:options
  customElement={{
    tag: "ofc-sustainability-badge-v1",
    /*                                            */
    extend: window.__components.extend(),
    props: {
      asButton: { type: "Boolean", attribute: "as-button" },
      variant: { type: "String" },
    },
  }}
/>

<script module>
  const variantMap = {
    "animal-welfare": "Berücksichtigt Tierwohl",
    "energy-efficient": "Energieeffiziente Nutzung",
    "social-initiatives": "Förderung Sozialer Initiativen",
    "recyclable-design": "Kreislauffähiges Design",
    "organic-materials": "Materialien aus biologischem Anbau",
    "natural-cosmetics": "Naturkosmetik",
    recycling: "Recycelte Materialien",
    production: "Verbesserte Herstellung",
    resource: "Verbesserte Rohstoffbeschaffung",
  } as const satisfies Record<Variant, string>;
</script>

<script lang="ts">
  import { OcIconV1Props } from "@otto-ec/otto-components/icon";
  import type { Props, Variant } from "./SustainabilityBadgeV1.types";

  let {
    asButton = false,
    variant = undefined,
    icon = undefined,
  }: Props = $props();

  const badgeVariant = $derived(
    variant ?? (icon?.replace("sustainable-", "") as Variant | undefined)
  );

  const ariaLabel = $derived(
    badgeVariant ? variantMap[badgeVariant] : "Invalid"
  );

  const iconType = $derived(
    icon ??
      (badgeVariant
        ? (`sustainable-${badgeVariant}` as const)
        : ("invalid" as never))
  );
</script>

{#snippet badgeIcon()}
  <oc-icon-v1
    oc-aria-label={ariaLabel}
    class="sustainability-badge__icon"
    size={"100"}
    type={iconType}
  ></oc-icon-v1>
{/snippet}

{#if asButton}
  <oc-interactive-overlay-v1
    class="sustainability-badge"
    class:sustainability-badge__interactive={asButton}
  >
    {@render badgeIcon()}
  </oc-interactive-overlay-v1>
{:else}
  <div
    class="sustainability-badge"
    class:sustainability-badge__interactive={asButton}
  >
    {@render badgeIcon()}
  </div>
{/if}

<style lang="scss" global>
  @use "../tokens" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :host {
    @include mixins.no-tap-highlight();
    display: block;
    outline: none;
    border-radius: 50%;
  }

  .sustainability-badge {
    display: block;
    position: relative;
    background-color: tokens.$oc-component-sustainability-badge-background-color;
    border-radius: 50%;
    border: none;
    height: tokens.$oc-component-sustainability-badge-background-size;
    width: tokens.$oc-component-sustainability-badge-background-size;
    outline: none;
    outline-offset: 0;

    &__icon {
      --color: #{tokens.$oc-component-sustainability-badge-icon-color};

      left: 50%;
      top: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
    }

    &__interactive {
      --border-radius: 50%;
      --border-offset: 0px; /*                                                    */
    }
  }
</style>
